import {
  ADD_PLACE_CONTACT,
  ADD_PLACE_CONTACT_FAILED,
  ADD_PLACE_CONTACT_SUCCESS,

  GET_PLACE_CONTACT_DETAILS,
  GET_PLACE_CONTACT_DETAILS_SUCCESS,
  GET_PLACE_CONTACT_DETAILS_FAILED,

  GET_PLACE_CONTACTS,
  GET_PLACE_CONTACTS_SUCCESS,
  GET_PLACE_CONTACTS_FAILED,

  EDIT_PLACE_CONTACT,
  EDIT_PLACE_CONTACT_SUCCESS,
  EDIT_PLACE_CONTACT_FAILED,

  DELETE_PLACE_CONTACT,
  DELETE_PLACE_CONTACT_SUCCESS,
  DELETE_PLACE_CONTACT_FAILED,
} from './actionTypes';

// GET PLACE CONTACTS
export const actionGetPlaceContacts = (payload) => ({
  payload,
  type: GET_PLACE_CONTACTS,
});

export const actionGetPlaceContactsSuccess = (payload) => ({
  payload,
  type: GET_PLACE_CONTACTS_SUCCESS,
});

export const actionGetPlaceContactsFailed = (payload) => ({
  payload,
  type: GET_PLACE_CONTACTS_FAILED,
});

// GET PLACE CONTACT DETAILS
export const actionGetPlaceContactDetails = (payload) => ({
  payload,
  type: GET_PLACE_CONTACT_DETAILS,
});

export const actionGetPlaceContactDetailsSuccess = (payload) => ({
  payload,
  type: GET_PLACE_CONTACT_DETAILS_SUCCESS,
});

export const actionGetPlaceContactDetailsFailed = (payload) => ({
  payload,
  type: GET_PLACE_CONTACT_DETAILS_FAILED,
});

// ADD PLACE CONTACT
export const actionAddPlaceContact = (payload) => ({
  payload,
  type: ADD_PLACE_CONTACT,
});

export const actionAddPlaceContactSuccess = (payload) => ({
  payload,
  type: ADD_PLACE_CONTACT_SUCCESS,
});

export const actionAddPlaceContactFailed = (payload) => ({
  payload,
  type: ADD_PLACE_CONTACT_FAILED,
});

// EDIT PLACE CONTACT
export const actionEditPlaceContact = (payload) => ({
  payload,
  type: EDIT_PLACE_CONTACT,
});

export const actionEditPlaceContactSuccess = (payload) => ({
  payload,
  type: EDIT_PLACE_CONTACT_SUCCESS,
});

export const actionEditPlaceContactFailed = (payload) => ({
  payload,
  type: EDIT_PLACE_CONTACT_FAILED,
});

// DELETE PLACE CONTACT
export const actionDeletePlaceContact = (payload) => ({
  payload,
  type: DELETE_PLACE_CONTACT,
});

export const actionDeletePlaceContactSuccess = (payload) => ({
  payload,
  type: DELETE_PLACE_CONTACT_SUCCESS,
});

export const actionDeletePlaceContactFailed = (payload) => ({
  payload,
  type: DELETE_PLACE_CONTACT_FAILED,
});
